import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=daa004e4&scoped=true"
import script from "./reject.vue?vue&type=script&lang=js"
export * from "./reject.vue?vue&type=script&lang=js"
import style0 from "./reject.vue?vue&type=style&index=0&id=daa004e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa004e4",
  null
  
)

export default component.exports